// Local
/*var backofficeUrl = 'http://127.0.0.1:8090/#'
var baseUrl = 'http://127.0.0.1:8080/servicecomplet/api/v1'*/

// Recette
/* var backofficeUrl = 'http://servicecomplet-bo-rec.suez.fr/#'
var baseUrl = 'https://servicecomplet-bo-rec-api.suez.fr/servicecomplet/api/v1'*/

// Hml
 var backofficeUrl = 'https://servicecomplet-bo-preprod.suez.fr/#'
var baseUrl = 'https://servicecomplet-bo-hml-api.suez.fr/servicecomplet/api/v1'


export {baseUrl, backofficeUrl}



// WEBPACK FOOTER //
// ./src/config.js